module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.active,
      "label-width": "140px"
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "已发布，报名中",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成，待结算",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "2"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "报名会议",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.member_list.length > 0) ? _c('div', {
          staticClass: "goods-name"
        }, [_vm._l((_vm.order.member_list), function(member, mkey) {
          return (mkey < 4) ? _c('span', {
            key: mkey
          }, [_vm._v(_vm._s(member.name) + " ")]) : _vm._e()
        }), _vm._v("\n              等" + _vm._s(scope.row.members) + "人报名\n            ")], 2) : _c('div', {
          staticClass: "goods-name"
        }, [_vm._v("\n              暂无人员报名\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "gray-light"
        }, [_vm._v("\n              " + _vm._s(scope.row.danwei) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "人数",
      "prop": "renshu"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.order_price > 0),
            expression: "scope.row.order_price>0"
          }],
          staticClass: "goods-price"
        }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(scope.row.order_price))]), _vm._v(" "), _c('div', {
          staticClass: "goods-num gray-light"
        }, [_vm._v("人数 " + _vm._s(scope.row.members))]), _vm._v(" "), (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n              已支付\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('div', [_vm._v("请去PC管理后台，编排出场顺序")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "prop": "riqi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.create_time_str) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.goDetail(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.onKaojiSelect({
          'name': '发布赛场考级'
        })
      }
    }
  }, [_vm._v("发布赛场考级\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onKaojiSelect({
          'name': '发布常规考级'
        })
      }
    }
  }, [_vm._v("发布常规考级\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onKaojiSelect
    },
    model: {
      value: (_vm.kaojiShow),
      callback: function($$v) {
        _vm.kaojiShow = $$v
      },
      expression: "kaojiShow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f518ffea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyListMine.vue
// module id = 1570
// module chunks = 0